<span
  class="sz-pill"
  [class.sz-pill--live]="variant() === 'live'"
  [class.sz-pill--outline]="variant() === 'outline'"
  [class.sz-pill--mixed]="variant() === 'mixed'"
  [class.sz-pill--dry]="variant() === 'dry'"
  [class.sz-pill--today]="variant() === 'today'"
  [class.sz-pill--next]="variant() === 'next'"
  [class.sz-pill--done]="variant() === 'done'"
  [class.sz-pill--saved]="variant() === 'saved'">
  <ng-content />
</span>
